import { registerFormatter } from './registry';
import { badge } from './badge';
import { bool } from './bool';
import { cellclass } from './cellclass';
import { chain } from './chain';
import { checkbox } from './checkbox';
import { checkmark } from './checkmark';
import { clicksink } from './clicksink';
import { date } from './date';
import { datetime } from './datetime';
import { gettext } from './gettext';
import { getvalue } from './getvalue';
import { join } from './join';
import { link } from './link';
import { mapvalue } from './mapvalue';
import { number } from './number';
import { routeLink } from './routeLink';
import { template } from './template';
import { text } from './text';
import { user } from './user';

let installed = false;

export function registerBuiltinFormatters(): void {
  if (installed) {
    return;
  }
  installed = true;

  registerFormatter('badge', badge);
  registerFormatter('bool', bool);
  registerFormatter('cellclass', cellclass);
  registerFormatter('chain', chain);
  registerFormatter('checkbox', checkbox);
  registerFormatter('checkmark', checkmark);
  registerFormatter('clicksink', clicksink);
  registerFormatter('date', date);
  registerFormatter('datetime', datetime);
  registerFormatter('gettext', gettext);
  registerFormatter('getvalue', getvalue);
  registerFormatter('join', join);
  registerFormatter('link', link);
  registerFormatter('mapvalue', mapvalue);
  registerFormatter('number', number);
  registerFormatter('routeLink', routeLink);
  registerFormatter('template', template);
  registerFormatter('text', text);
  registerFormatter('user', user);
}

export {
  registerFormatter,
  getFormatterFactory,
  hasFormatter,
  resolveFormatter,
} from './registry';
export { chain };
export type { ChainOptions, ChainContextSource } from './chain';
export {
  collectionRenderer,
  collectionSeparator,
  isCollectionFormatter,
} from './collection';
export { toDate } from './date';
export type { BadgeOptions } from './badge';
export type { MapValueOptions } from './mapvalue';
export type { CellClassOptions } from './cellclass';
export type { GetValueOptions } from './getvalue';
export type { GetTextOptions } from './gettext';
export type { JoinOptions } from './join';
export type { LinkOptions } from './link';
export type { RouteLinkOptions } from './routeLink';
export type { NumberOptions } from './number';
export type { DateOptions } from './date';
export type { DateTimeOptions } from './datetime';
export type { BoolOptions } from './bool';
export type { CheckmarkOptions } from './checkmark';
